import { Option } from '../../../../shared/options/domain/option';
import { CriteriaKey } from '../criteria';

export const glueOption: Option<CriteriaKey> = {
  name: 'AWS Glue Jobs',
  description:
    'A fully managed extract, transform, and load (ETL) service that makes it easy to prepare data for analytics.',
  tags: ['ETL', 'Serverless'],
  pros: ['Scalable', 'Reliable', 'Secure'],
  cons: ['Flexibility', 'Complexity'],
  documentationLink: 'https://aws.amazon.com/glue/',
  criteriaScores: {
    asyncExecution: { score: { value: 7 } },
    scalability: { score: { value: 10 } },
    unlimitedExecutionTimeout: { score: { value: 10 } },
    storagePersistance: { score: { value: 1 } },
    vendorLockIn: { score: { value: 1 } },
    containerizationLimitations: { score: { value: 10 } },
    operationalManagement: { score: { value: 3 } },
    etlOriented: { score: { value: 10 } },
    batchingProcessing: { score: { value: 1 } },
  },
};
